<template>
  <div :class="getCustomClass()">
    <div v-for="(row,index) in policyList" :key="index" class="part5">
      <div class="part_section" :id="row.id"></div>
      <div class="blur_bd_title" v-html="row.title"></div>
      <div class="part5_bd">
        <template v-for="(item,childrenIndex) in row.children">
            <dl :key="childrenIndex" class="text_box fix">
              <template v-if="row.id==='section4'">
                  <dt class="text_hd f-fl">签证说明</dt>
                  <dd class="text_bd f-fl content_html" v-html="item.content"></dd>
                  <template v-if="item&&item.insuranceContent">
                    <dt class="text_hd f-fl">保险说明</dt>
                    <dd class="text_bd f-fl content_html" v-html="item.insuranceContent"></dd>
                  </template>
                  
              </template>
              <template v-else>
                <dt class="text_hd f-fl">{{item.contentType}}</dt>
                <dd class="text_bd f-fl content_html" v-html="item.content"></dd>
              </template>
            </dl>
        </template>
      </div>
    </div>
    <BankPopup :isShow="isShowBankPopup" v-on:onModalClose="closeBankPopup" />
  </div>
</template>

<script>
import api from '@/api'
import { SpecialBookingType } from "@/utilities/specialBookingHelper";
// const NrpTable = () => import("@/components/Booking/NrpTable.vue");
const BankPopup = () => import("@/components/Booking/BankPopup.vue");
import { isHkSpecialCruise } from "@/utilities/tools";
export default {
  name: "CruiseDetailPolicy",
  components: {
    // NrpTable,
    BankPopup,
  },
  props: {
    visaContent: {
      type: Object,
      default() {
        return {
          visaContent: "",
          hkGuestContent: "",
          insuranceContent: "",
          insuranceBrief: "",
        };
      },
    },
    departureCode: {
      type: String,
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isSevenDayNrpCruise: {
      type: Boolean,
      default() {
        return false;
      },
    },
    shipCode: {
      type: String,
    },
    sailDate: {
      type: String,
    },
    shipName: {
      type: String,
    },
    portAddress: {
      type: String,
    },
    customClass: {
      type: String,
    },
    hasNrp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    hasRp: {
      type: Boolean,
      default() {
        return false;
      },
    },
    specialBookingInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    isDownPayCruise: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showRow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowBankPopup: false,
      policyList: [
        { id: "section3", title: "费用<br />说明", categoryIds: [1,2], children: []},
        { id: "section4", title: "签证及<br />保险", categoryIds: [3], children: []},
        { id: "section5", title: "预订及<br />退改", categoryIds: [4,5,6], children: []},
        { id: "section6", title: "支付及<br />发票", categoryIds: [7], children: []},
        { id: "section7", title: "办理<br />登船", categoryIds: [8], children: []}
      ]
    };
  },
  created() {
    this.getPolicy();
  },
  methods: {
    getCustomClass() {
      let customClass = {};
      if (this.customClass && this.customClass.length > 0) {
        customClass[this.customClass] = true;
      }
      return customClass;
    },
    showBankPopup() {
      this.isShowBankPopup = true;
    },
    closeBankPopup() {
      this.isShowBankPopup = false;
    },
    async getPolicy() {
      this.$loading.show();
      const userToken = this.userToken;
      let requestData = {
        userName: userToken || '',
        isTui: this.showRow,
      }
      let params = {
        shipCode:this.shipCode,
        sailDate:this.sailDate
      }

      if(this.hasNrp) params['isNrp'] = true;
      if(this.hasRp) params['isRp'] = true;

      const { data } = await api.booking.getPolicyContentList(requestData,params);
      if (data) {
        this.policyList && this.policyList.forEach((row)=> {
          data && data.forEach((item)=> {
            if(row.categoryIds.includes(item.categoryId)) {
              if(item.categoryId === 6) {
                if(this.isBirthday) row.children.push({...item})
              } else {
                row.children.push({...item})
              }
            }
          })
        })
        // { id: "section3", title: "费用<br />说明", categoryId: [1,2]}
        // { id: "section4", title: "签证及<br />保险", categoryId: [3]}
        // { id: "section5", title: "预订及<br />退改", categoryId: [4,5,6] isBirthday}
        // { id: "section6", title: "支付及<br />发票", categoryId: [7]}
        // { id: "section7", title: "办理<br />登船", categoryId: [8]}
      }
      this.$loading.hide();
    }
  },
  computed: {
    userToken() {
      return this.$store.state.user.userToken;
    },
    shipLink() {
      if (this.shipCode === "WN") {
        return "https://www.rcclchina.com.cn/privilege/WN2021";
      }
      return (
        process.env.VUE_APP_BASE_URL + "/content/taste/ships/" + this.shipCode
      );
    },
    boardingTime() {
      return "11:30-15:00";
    },
    isFromGuestInfo() {
      return this.getCustomClass().guestInfo;
    },
    isBirthday() {
      if (
        this.specialBookingInfo &&
        this.specialBookingInfo.specialBookingType > 0
      ) {
        return (
          this.specialBookingInfo.specialBookingType ==
          SpecialBookingType.Birthday
        );
      }
      return false;
    },
    isShowNrp() {
      return this.shipCode != "WN";
    },
    isShowRp() {
      return true;
    },
    isHkSpecialCruise() {
      return isHkSpecialCruise(
        this.shipCode,
        this.sailDate,
        this.departureCode
      );
    }
  },
};
</script>

<style lang="less" scoped>
.part5 {
  position: relative;
  background: #fff;
  border-bottom: 15px #f5f5f5 solid;
  .part5_bd {
    min-height: 200px;
    padding: 30px 20px 20px 100px;
    .text_box {
      padding: 0px 20px 0px 0px;
      .text_hd {
        width: 10%;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        margin-right: 1%;
        padding-left: 10px;
      }
      .text_hd:after {
        content: "";
        position: absolute;
        left: 0;
        top: 4px;
        width: 3px;
        height: 15px;
        display: block;
        background: #54a3de;
      }
      .text_bd {
        width: 89%;
        line-height: 1.8;
        margin-bottom: 20px;
        .text-subtitle {
          font-size: 14px;
          color: #282b2c;
          font-weight: 700;
          position: relative;
          top: -2px;
        }
      }
    }
  }

  .blur_bd_title {
    position: absolute;
    top: 16px;
    left: -5px;
    width: 82px;
    padding: 10px 0px 20px;
    background: url(https://resource.rcclchina.com.cn/tui2/detail/part4_title_bj.png)
      no-repeat center;
    text-align: center;
    line-height: 78px;
    font-size: 20px;
    color: #fff;
    line-height: 1.2;
  }
}

.guestInfo {
  .part5_bd {
    color: #747d80;
    padding-left: 0px;
    padding-top: 0px;
    .text_box .text_hd {
      width: 16%;
      margin-right: 0px;
    }
    .text_box .text_bd {
      width: 84%;
    }
  }
  .blur_bd_title {
    display: none;
  }
  .to_ship {
    display: none;
  }
}
</style>

<style lang="less">
.part5 .part5_bd .text_box .text_bd p {
  margin: 0px;
}
.insurance_html {
  .insurance_txt {
    .visa_right__titlt {
      font-weight: bold !important;
      //margin-top: 16px !important;
      color: #282b2c !important;
    }
  }
}
.content_html {
    p{
      img{
        max-width: 100%;
      }
    }
  .visa_right__titlt {
    font-weight: bold;
    //margin-top: 16px !important;
    color: #282b2c;
    margin-top: 20px !important;
    &:first-child {
      margin-top: 0 !important;
    }
  }
  .reservation_desc {
    .visa_right__titlt {
      font-weight: bold !important;
      //margin-top: 16px !important;
      color: #282b2c !important;
    }
    .table {
      border-collapse: collapse;
      border: 1px solid #E0E0E0;
      & td,th {
        padding: 10px;
        line-height: 1.8;
        border: 1px solid #E0E0E0;
        & .orderInfo__alterTickets-title {
          font-weight: bold;
          text-align: center;
        }
      }
      & .th {
        font-weight: normal;
      }
    }
  }
  .payWays {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-bottom: 10px;
  }
  .payWays.wechatPay {
    margin-top: 5px;
  }
  .payWays .payIcon {
    width: 30px !important;
  }
  .reservation_desc ul {
    padding-left: 15px;
  }
  .reservation_desc ul li {
    list-style: disc;
  }
  & img {
    max-width: 100%;
    height:auto;
  }
}
</style>
